import React, { useContext, useEffect, useState, useMemo } from 'react'
import LabelTopView from '../Utility/LabelTopView';
import { ChartBarBigIcon } from 'lucide-react';
import HeaderWithButton from '../Utility/HeaderWithButton';
import TableHeader from '../Utility/TableHeader';
import { use } from 'react';
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { Pagination } from '../../helper/HelperTwo';
import Select from "react-select";
import { DataContext } from '../../helper/HelperOne';
import { useExcelDownload, usePDFDownload } from "../../helper/HelperTwo";
import { Dialog, Transition } from "@headlessui/react";
import { ChatBubbleBottomCenterIcon, ClipboardDocumentListIcon, DocumentChartBarIcon } from '@heroicons/react/24/outline';
import { Tooltip } from 'react-tooltip';
import PaymentReceivableBill from './PaymentReceivableBill';


const PaymentReceivableList = () => {
  const tabName = localStorage.getItem("tab_name");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [PaymentReceivableList, setPaymentReceivableList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState(null);
  const { searchData } = useContext(DataContext);
  const { PDFDownload } = usePDFDownload();
  const { excelDownload } = useExcelDownload();
  const [filtersReset, setFiltersReset] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [PaymentReceivableId, setPaymentReceivableId] = useState(null);

  const [filter, setFilter] = useState({
    type_of_work: "",
    sales_person: "",
    project_manager: "",
    collection_person: "",
  });
  const [salesmanData, setSalesmanData] = useState([]);
  const [workersData, setWorkersData] = useState([]);
  const [typeOfWork, setTypeOfWork] = useState([]);
  const [projectManagerList, setProjectManagerList] = useState([]);
  const [colors, setColors] = useState([]);
  const [collectionPerson, setCollectionPerson] = useState([]);

  const salesServiceOptions = [
    {
      value: "sales",
      name: "Sales",
    },
    {
      value: "service",
      name: "Service",
    },
  ];

  const fetchPaymentReceivable = async (page = 1) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const url = `public/api/payment-receivables?page=${page}`

      if (searchData) {
        url += `&search=${searchData}`
      }
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      const getCollectionPerson = await axios.get('public/api/payment-receivables/collection/person', {
        headers: { Authorization: `Bearer ${token}` },
      })
      const [salesmanResponse, typeOfWorkResponse, projectManagerResponse,] = await Promise.all([
        axios.get('public/api/salesmen/list', {
          headers: { Authorization: `Bearer ${token}` },
        }),

        axios.get('public/api/type-of-works/list', {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get('public/api/project-manager/list', {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ])


      console.log(getCollectionPerson)
      setCollectionPerson(getCollectionPerson?.data?.collection_person)
      setSalesmanData(salesmanResponse?.data);

      setTypeOfWork(typeOfWorkResponse?.data);
      setProjectManagerList(projectManagerResponse?.data);

      setPaymentReceivableList(response?.data?.payment_receivables?.data);
      setPagination(response?.data?.payment_receivables);

      const PaymentReceivable = response?.data?.payment_receivables?.data || [];
      const uniqueWorks = [
        ...new Set(PaymentReceivable.map((q) => q.type_of_work).filter(Boolean)),
      ];
      const colorList = generateColors(uniqueWorks.length);
      setColors(colorList);

    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchPaymentReceivable();
  }, [searchData]);


  const randomColorMap = useMemo(() => {
    const map = {};
    if (!PaymentReceivableList || PaymentReceivableList.length === 0 || !colors?.length) return map;

    const uniqueWorks = [
      ...new Set(PaymentReceivableList.map((lead) => lead?.type_of_work).filter(Boolean)),
    ];

    uniqueWorks.forEach((work, index) => {
      map[work] = colors[index % colors.length]; // assign color deterministically
    });

    return map;
  }, [PaymentReceivableList, colors]);
  const generateColors = (count) => {
    const colors = [];

    for (let i = 0; i < count; i++) {
      const hue = Math.floor(Math.random() * 360); // full color range
      const saturation = Math.floor(Math.random() * 40) + 70; // 70–100% = very colorful
      const lightness = Math.floor(Math.random() * 30) + 20; // 60–90% = bright

      const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
      colors.push(color);
    }

    return colors;
  };

  const handleFilter = async (page = 1) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const queryParams = new URLSearchParams({
        page: page,
        type_of_work: filter?.type_of_work || "",
        sales_person: filter?.type_of_work || "",
        project_manager: filter?.type_of_work || "",
        collection_person: filter.collection_person || "",
        search: searchData,
      }).toString();

      const response = await axios.get(`public/api/payment-receivables?${queryParams}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        },
      });


      setPaymentReceivableList(response?.data?.payment_receivables?.data);

      setPagination(response?.data?.payment_receivables);

      const PaymentReceivable = response?.data?.payment_receivables?.data || [];
      const uniqueWorks = [
        ...new Set(PaymentReceivable.map((q) => q.type_of_work).filter(Boolean)),
      ];
      const colorList = generateColors(uniqueWorks.length);
      setColors(colorList);

    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      }
      setError("Network Failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  const resetFilters = async () => {
    setLoading(true);
    setFilter({
      type_of_work: "",
      sales_person: "",
      project_manager: "",
      collection_person: "",
    });
    setLoading(false);
    setFiltersReset(true);
  };

  useEffect(() => {
    if (filtersReset) {
      fetchPaymentReceivable(1);
      setFiltersReset(false);
    }
  }, [filtersReset]);


  const handleDownloadPDF = () => {
    const params = {
      type_of_work: filter?.type_of_work || "",
      sales_person: filter?.type_of_work || "",
      project_manager: filter?.type_of_work || "",
      collection_person: filter?.collection_person || "",
    };

    PDFDownload("payment-receivables", "payment-receivables.pdf", params, setLoading);
  }

  const handleDownloadExcel = () => {
    const params = {
      type_of_work: filter?.type_of_work || "",
      sales_person: filter?.type_of_work || "",
      project_manager: filter?.type_of_work || "",
      collection_person: filter?.collection_person || "",
    };
    excelDownload("payment-receivables", "payment-receivables.xlsx", params, setLoading);
  };

  const handlePageChange = (page) => {
    if (page !== "...") {
      handleFilter(page);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };

  const handleViewFormPaymentBill = (id) => {
    setPaymentReceivableId(id);
    setIsOpen(true);
  }

  const handleClose = () => {
    setIsOpen(false);
    fetchPaymentReceivable();
  }

  const headers = [
    "SNO",
    "Receipt No",
    "Account Name",
    "Party Name",
    "Mobile No",
    "Type of Work",
    "Sales Person",
    "Collection Person",
    "Project Manager",
    "Total Amount",
    "Action",
  ]

  if (loading) {
    return (
      <div className="h-screen bg-white">
        <div className="flex justify-center items-center h-full">
          <img
            className="h-16 w-16"
            src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
            alt="loader"
          />
        </div>
      </div>
    );
  }


  if (error) {
    <div className="h-screen bg-white flex flex-col justify-center items-center">
      <p className="mb-4 text-red-600 font-medium">Something went wrong.</p>
      <button
        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        onClick={() => {
          setError(null); // hide error while retrying
          fetchPaymentReceivable(); // retry API
        }}
      >
        Reload
      </button>
    </div>;
  }
  return (
    <div>
      <div className="flex flex-col lg:flex-row justify-between items-center gap-4 mb-4">
        <div className="flex-1">
          <LabelTopView label="Payment Receivables Overview" icon={<ChartBarBigIcon />} />
        </div>
      </div>
      <HeaderWithButton
        title="Payment Receivable "
        description="Payment Receivable List"
        buttonText="PaymentReceivable"
        // onButtonClick={handleAddLead}
        showButton={false}
      />


      <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 items-end mt-4">
        {/* Date filter */}

        {/* salesman Dropdown */}
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sales Person
          </label>
          <Select
            name="sales_person"
            options={salesmanData?.map((cust) => ({
              value: cust.name,
              label: cust.name,
            }))}
            value={
              salesmanData
                ?.map((cust) => ({
                  value: cust.name,
                  label: cust.name,
                }))
                .find((cust) => cust.value === filter.sales_person) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "sales_person",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Sales Person"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Project Manager
          </label>
          <Select
            name="project_manager"
            options={projectManagerList?.map((cust) => ({
              value: cust?.name,
              label: cust?.name,
            }))}
            value={
              projectManagerList?.map((cust) => ({
                value: cust?.name,
                label: cust?.name,
              }))
                .find((cust) => cust.value === filter?.project_manager) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "project_manager",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Project Manager"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>



        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Type of Work
          </label>
          <Select
            name="type_of_work"
            options={typeOfWork?.map((work) => ({
              value: work.name,
              label: work.name,
            }))}
            value={
              // Find the option where option.value matches filter.type_of_work
              typeOfWork
                ?.map((work) => ({ value: work.name, label: work.name }))
                .find((option) => option.value === filter.type_of_work) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "type_of_work",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Type of Work"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Collection Person
          </label>
          <Select
            name="collection_person"
            options={collectionPerson?.map((work) => ({
              value: work?.collection_person,
              label: work?.collection_person,
            }))}
            value={
              // Find the option where option.value matches filter.collection_person
              collectionPerson
                ?.map((work) => ({ value: work.collection_person, label: work.collection_person }))
                .find((option) => option.value === filter.collection_person) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "collection_person",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Collection Person"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>







      </div>

      <div className="flex flex-wrap gap-4 mt-4">
        {/* Submit Button */}
        <button
          // ref={submitBtnRef}
          onClick={() => handleFilter(1)}
          className="bg-blue-600 text-white font-semibold py-2 px-6 rounded-md hover:bg-blue-700 transition"
        >
          Submit
        </button>

        {/* Reset Button */}
        <button
          onClick={resetFilters}
          className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
        >
          Reset
        </button>
        <button
          onClick={handleDownloadPDF}
          className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
        >
          PDF
        </button>
        <button
          onClick={handleDownloadExcel}
          className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
        >
          Excel
        </button>
      </div>

      <div className="overflow-x-auto mt-8">
        <table className="min-w-full border border-gray-300 border-collapse">
          <TableHeader headers={headers} />
          <tbody>
            {PaymentReceivableList?.length > 0 ? (
              PaymentReceivableList?.map((data, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition duration-300 ease-in-out"
                >
                  <td className="border border-gray-300 whitespace-nowrap text-md sm:pl-4 text-center">
                    {pagination?.from + index}
                  </td>

                  <td
                    className="border  border-gray-300 whitespace-nowrap text-md text-blue-500 sm:pl-4 text-center p-5"

                  >
                    {data?.receipt_no || "N/A"}
                  </td>

                  <td
                    className="border  border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"

                  >
                    {data?.account_name || "N/A"}
                  </td>

                  <td
                    className="border  border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"

                  >
                    {data?.party_name || "N/A"}
                  </td>
                  <td
                    className="border  border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                  >

                    {/* <a href={`tel:${data?.mobile_no}`}>
                      {" "}
                      {data?.mobile_no || "N/A"}{" "}
                    </a> */}

                    {data?.mobile_no ? (
                      <a href={`tel:${data.mobile_no}`}>
                        {data.mobile_no}
                      </a>
                    ) : (
                      <span className="text-gray-400">N/A</span>
                    )}

                  </td>
                  <td
                    className="border  border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"

                  >

                    <span
                      className="text-xs rounded px-1"
                      style={{
                        color: randomColorMap[data?.type_of_work],
                        border: `1px solid ${randomColorMap[data?.type_of_work]
                          }`,
                      }}
                    >
                      {data?.type_of_work || "N/A"}
                    </span>

                  </td>
                  <td
                    className="border  border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"

                  >
                    {data?.sales_person || "N/A"}
                  </td>
                  <td
                    className="border  border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"

                  >
                    {data?.collection_person || "N/A"}
                  </td>
                  <td
                    className="border  border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"

                  >
                    {data?.project_manager || "N/A"}
                  </td>
                  <td
                    className="border  border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                  >
                    {data?.total_amount || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-center align-middle p-5">
                    <div className="flex space-x-2 justify-center items-center">
                      <span
                        className="my-anchor-bill_allocations relative group cursor-pointer bg-blue-400 rounded-md p-1"
                        onClick={() => handleViewFormPaymentBill(data.id_crypt)}
                      >
                        <ClipboardDocumentListIcon className="h-5 w-5 text-white" />
                        <Tooltip
                          anchorSelect=".my-anchor-bill_allocations"
                          place="top"
                          className="text-xs p-0"
                          style={{ fontSize: "12px", padding: "0.3rem" }}
                        >
                          Bill Allocations
                        </Tooltip>
                      </span>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers.length} className="py-4 px-6 text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>


        </table>
      </div >
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="relative z-10"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
            <Dialog.Panel className="relative transform overflow-hidden p-2 sm:p-0 rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-5xl sm:p-4">
              <PaymentReceivableBill idCrypt={PaymentReceivableId} close={handleClose} />
            </Dialog.Panel>
          </div>
        </div>

      </Dialog>

      {pagination && (
        <Pagination
          links={pagination.links}
          currentPage={pagination.current_page}
          totalResults={pagination.total}
          from={pagination.from}
          to={pagination.to}
          lastPage={pagination.last_page}
          onPageChange={handlePageChange}
        />
      )}
    </div >
  )
}

export default PaymentReceivableList